import { useEffect, useState } from 'react'
import { getShelfs } from 'src/api/getBraindwShelfs'
import { useBraindw } from 'src/components/hooks/useBraindw'
import { useSession } from 'src/sdk/session'
import { productBraindwMapper } from 'src/utils/productBraindwMapper'

import ProductShelfBraindw from './ProductShelfBraindw'

const ShelfBraindw = ({ ids }: { ids: string }) => {
  const session = useSession()

  const { braindwObject } = useBraindw({
    ids: [ids],
    session,
  })

  const [products, setProducts] = useState<BraindwMappedProducts[][]>([])

  useEffect(() => {
    if (braindwObject) {
      getShelfs(braindwObject).then((brainDwResponse) => {
        const productsMapped = productBraindwMapper(brainDwResponse)

        setProducts(productsMapped)
      })
    }
  }, [braindwObject])

  if (products.length === 0 || braindwObject?.length === 0) {
    return null
  }

  return (
    <>
      {braindwObject?.map((item: BraindwObjectProps, index: number) => {
        return (
          <>
            <ProductShelfBraindw
              key={index}
              title={item?.Title}
              eventAction={item?.GaEventAction}
              products={products[index]}
            />
          </>
        )
      })}
    </>
  )
}

export default ShelfBraindw
